import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute, ProtectedRouteBare } from "./components/protected-route";
import { AppLayout } from "./components/layout/app-layout";
import { LoginPage } from "./pages/login";
import { SignupPage } from "./pages/signup";
import { VerifyEmailPage } from "./pages/verify-email";
import { ForgotPasswordPage } from "./pages/forgot-password";
import { ResetPasswordPage } from "./pages/reset-password";
import { AuthCallbackPage } from "./pages/auth-callback";
import { BillingSettingsPage } from "./pages/settings/billing";
import { ApiKeySettingsPage } from "./pages/settings/api-key";
import { ProfileSettingsPage } from "./pages/settings/profile";

/**
 * Main App component with routing
 *
 * Home page uses AppLayout (chat + sidebar) which renders its own header.
 * Settings pages use ProtectedRoute layout with standard AppHeader.
 */
export function App(): React.ReactElement {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      {/* Protected routes: home uses bare wrapper (AppLayout has its own header) */}
      <Route element={<ProtectedRouteBare />}>
        <Route path="/" element={<AppLayout />} />
      </Route>

      {/* Protected routes: settings use standard wrapper with header */}
      <Route element={<ProtectedRoute />}>
        <Route path="/settings/profile" element={<ProfileSettingsPage />} />
        <Route path="/settings/billing" element={<BillingSettingsPage />} />
        <Route path="/settings/api-key" element={<ApiKeySettingsPage />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
